import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { IGeoBounds } from "utils/geo";

type TInput = { location: string };
type TOutput = { bounds: IGeoBounds };

export default class Location2JsonApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.POST;

  resolveUri(): string {
    return `/fe-api/address/location2json`;
  }

  mapResponseData(_: number, data: any): TOutput | null {
    if (data.json === null) {
      return null;
    }

    const { geometry }: { geometry: any } = data.json;
    const bounds = geometry.bounds || geometry.viewport;

    return {
      bounds: {
        northEast: {
          lat: bounds.northeast.lat as number,
          lng: bounds.northeast.lng as number,
        },
        southWest: {
          lat: bounds.southwest.lat as number,
          lng: bounds.southwest.lng as number,
        },
      },
    };
  }
}
